import React from "react";
import { Slide } from "@material-ui/core";

export default function TransitionRight(props) {
  return <Slide {...props} direction="right" />;
}
